<template>
  <el-dialog
    title="填写发货信息"
    :visible.sync="visible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="110px" :rules="rules">
      <el-form-item label="物流公司" prop="expressCompany">
        <el-select
          v-model="form.expressCompany"
          reserve-keyword
          placeholder="请选择物流公司"
          style="width:300px;"
        >
          <el-option
            v-for="item in options"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物流单号" prop="expressNum">
        <el-input
          type="text"
          placeholder="请输入物流单号"
          v-model="form.expressNum"
          style="width:300px;"
        ></el-input>
      </el-form-item>
      <el-row type="flex" justify="end" style="margin-top: 45px;">
        <el-button
          class="standard-button"
          style="margin-right: 10px;"
          @click="handleClose"
          >取消</el-button
        >
        <el-button
          class="standard-button"
          type="primary"
          :loading="loading"
          @click="handlerConfirm"
          >确认</el-button
        >
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'DeliveryDialog',
  data() {
    return {
      options: ['京东', '顺风', '中通', '圆通', '韵达'],
      form: {
        expressNum: '',
        expressCompany: '',
      },
      rules: {
        expressCompany: [
          { required: true, message: '请选择物流公司', trigger: 'change' },
        ],
        expressNum: [
          { required: true, message: '请输入物流单号', trigger: 'blur' },
        ],
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handlerConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form);
        }
      });
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleClose() {
      this.resetForm();
      this.$emit('update:visible', false);
    },
  },
};
</script>
